import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog, MatDialogContent, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { AlertService, AlertType } from '../../../services/alert.service';
import { LoginComponent } from '../login.component';
import { PasswordChangeService } from '../../../services/apis/platform/password-change.service';
import { RecoverPasswordRequest } from '../../../services/requests/platform/recover-password.request';
import { RecoverPasswordResponse } from '../../../services/responses/platform/recover-password.response';

@Component({
  selector: 'app-password-recovery',
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    MatButtonModule,
    MatDialogContent,
    MatProgressSpinnerModule,
    MatIconModule,
    MatProgressSpinnerModule, 
    CommonModule
  ],
  templateUrl: './password-recovery.component.html',
  styleUrl: './password-recovery.component.css'
})
export class PasswordRecoveryComponent {
 constructor(
    private formBuilder: FormBuilder,
    private alertService: AlertService,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<PasswordRecoveryComponent>,
    public passwordChangeService:PasswordChangeService
  ) {}
  public model: FormGroup;
  public _isLoading: boolean = false;

  ngOnInit(): void {
    this.model = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
    });
  }

  openModalLogin(){
    this.dialogRef.close();
    const dialogRef = this.dialog.open(LoginComponent, {
      data: {},
      //panelClass: 'dialog-search-invite-client'
    });

    dialogRef.afterClosed().subscribe(result => {
      
    });
  }

  post(){
    if (this.model.invalid || this._isLoading) {
      return;
    }

    this._isLoading = true;

    let recoverPasswordRequest:RecoverPasswordRequest = new RecoverPasswordRequest();
    recoverPasswordRequest.email = this.model.get("email")?.value;

    this.passwordChangeService.post(recoverPasswordRequest).subscribe({
      next: (response: RecoverPasswordResponse) => {
        if (response.isError) {
          this.alertService.show('Erro', response.errorDescription, AlertType.error);
          this._isLoading = false;
          return;
        }

        this.alertService.show('Sucesso', "Confira seu email para poder redefinir sua senha", AlertType.success);

        this.dialogRef.close();
      },
      error: error => {
        this.alertService.show('Erro inesperado', error.message, AlertType.error);
        this._isLoading = false;
      },
    });
  }
}
